
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_wih1l_chj77_97",
  "tools": "awsui_tools_wih1l_chj77_108",
  "tools-filtering": "awsui_tools-filtering_wih1l_chj77_116",
  "tools-align-right": "awsui_tools-align-right_wih1l_chj77_130",
  "tools-pagination": "awsui_tools-pagination_wih1l_chj77_134",
  "tools-preferences": "awsui_tools-preferences_wih1l_chj77_134",
  "tools-small": "awsui_tools-small_wih1l_chj77_140",
  "table": "awsui_table_wih1l_chj77_146",
  "table-layout-fixed": "awsui_table-layout-fixed_wih1l_chj77_152",
  "wrapper": "awsui_wrapper_wih1l_chj77_156",
  "variant-stacked": "awsui_variant-stacked_wih1l_chj77_163",
  "wrapper-content-measure": "awsui_wrapper-content-measure_wih1l_chj77_163",
  "variant-container": "awsui_variant-container_wih1l_chj77_163",
  "has-footer": "awsui_has-footer_wih1l_chj77_166",
  "has-header": "awsui_has-header_wih1l_chj77_169",
  "cell-merged": "awsui_cell-merged_wih1l_chj77_186",
  "cell-merged-content": "awsui_cell-merged-content_wih1l_chj77_198",
  "empty": "awsui_empty_wih1l_chj77_216",
  "loading": "awsui_loading_wih1l_chj77_220",
  "selection-control": "awsui_selection-control_wih1l_chj77_229",
  "selection-control-header": "awsui_selection-control-header_wih1l_chj77_236",
  "dark-header": "awsui_dark-header_wih1l_chj77_246",
  "header-secondary": "awsui_header-secondary_wih1l_chj77_251",
  "table-has-header": "awsui_table-has-header_wih1l_chj77_269",
  "header-controls": "awsui_header-controls_wih1l_chj77_273",
  "variant-full-page": "awsui_variant-full-page_wih1l_chj77_276",
  "variant-embedded": "awsui_variant-embedded_wih1l_chj77_282",
  "variant-borderless": "awsui_variant-borderless_wih1l_chj77_282",
  "footer-wrapper": "awsui_footer-wrapper_wih1l_chj77_287",
  "footer": "awsui_footer_wih1l_chj77_287",
  "footer-with-pagination": "awsui_footer-with-pagination_wih1l_chj77_295",
  "footer-pagination": "awsui_footer-pagination_wih1l_chj77_303",
  "thead-active": "awsui_thead-active_wih1l_chj77_307",
  "row": "awsui_row_wih1l_chj77_308",
  "row-selected": "awsui_row-selected_wih1l_chj77_309"
};
  